<template>
    <div class="edu-frame">
        <edu-nav-bar title="历史报读班级" :show="show" @showPopup="show=true"
                     @hidePopup="show=false"></edu-nav-bar>
        <div class="content-frame">
            <div class="edu-group" style="margin: 20px auto 15px;">
                <div class="title-tips">历史报读班级列表：</div>
            </div>
            <div v-for="(term, key) in regClassMasters" :key="key">
                <div v-for="(rms, index) in term" :key="index">
                    <div v-for="(master, mkey) in rms" :key="mkey">
                        <div class="class-list">
                            <div class="edu-group class-item" style="flex-direction: column;">
                                <div class="class-detail-title" style="color: red;">{{key}}</div>
                            </div>
                            <div class="edu-group class-item" style="flex-direction: column;">
                              <div style="display: flex;">
                                <div class="class-detail">
                                  <div class="class-detail-title">单号：{{mkey}}</div>
                                  <div class="class-detail-more">提交时间：{{master[0].billDate | filterDate}}</div>
                                </div>
                                <div>
                                  <van-button v-if="master[0].etaxUrl != null && master[0].etaxUrl !== ''" type="info" size="small" @click="toTaxURL(master[0].etaxUrl)">下载发票</van-button>
<!--                                  <van-button v-else type="warning" size="small">发票处理中</van-button>-->
                                </div>
                              </div>
                            </div>
                            <div v-for="(detail, detailIndex) in master" :key="detailIndex">
                                <div class="edu-group class-item">
                                    <div class="class-detail">
                                        <div class="class-detail-title">
                                            <div class="class-detail-title-name">{{detail.className}}</div>
                                            <van-tag type="success">已缴费</van-tag>
                                        </div>
                                        <div class="class-detail-more">
                                            <div class="class-detail-title-name">
                                                <div>上课时间：{{detail.classTime}}</div>
                                                <div class="class-detail-row">
                                                    <div class="class-detail-row-title">任课老师：{{detail.teacherId}}</div>
                                                    <div class="class-detail-row-title">学费：<label class="txt-price">{{detail.rcMoney}}元</label>
                                                    </div>
                                                </div>
                                                <div class="class-detail-row">
                                                    <div class="class-detail-row-title">上课地点：{{detail.classRoomName}}</div>
                                                </div>
                                                <div class="class-detail-row">
                                                    <div class="class-detail-row-title">上课时间：{{detail.termBegins}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="class-split"/>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import {Tag, Button} from "vant";
    import EduNavBar from "@/components/EduNavBar";
    import BaomingApi from "@/api/BaomingApi";
    import Tools from "@/api/Tools";
    import EduConstants from '@/api/EduConstants';
    import XEUtils from "xe-utils";

    export default {
        components: {
            EduNavBar,
            VanTag: Tag,
            VanButton: Button
        },
        filters: {
            filterDate(date) {
                return XEUtils.toDateString(date, 'yyyy-MM-dd HH:mm:ss')
            }
        },
        data() {
            return {
                cust: Tools.getCurCust(),
                LOGINTYPE_CHILD: EduConstants.LOGINTYPE_CHILD,
                show: false,
                regClassMasters: [],
                datas: [],
                payTotal: 0,
                // reportData: '',
                refunds: [],
                loading: false
            }
        },
        methods: {
            getAlreadyBaoduClasses() {
                BaomingApi.getAlreadyBaoduClasses({custId: this.cust.custId, loginType: this.cust.loginType, reportType: 'lsbdbj'}).then(response => {
                    console.log(response.res)
                    this.regClassMasters = response.res.datas
                    this.payTotal = response.res.payTotal
                    // this.reportData = response.res.reportData
                })
            },
            toTaxURL(eTaxUrl) {
              console.log(eTaxUrl)
              window.location.href = eTaxUrl
            }
        },
        mounted() {
            this.getAlreadyBaoduClasses()
        }
    }
</script>
<style scoped>
    .content-frame {
        height: calc(100% - 46px);
    }
    .class-list {
        width: 95%;
        border-radius: 8px;
        border: 1px solid lightgrey;
        box-shadow: 1px 2px 2px #ddd;
        margin: 10px auto;
        padding: 8px 0px;
        background-color: #cde7f7;
    }

    .title-tips {
        margin-left: 2%;
        font-size: 16px;
        font-weight: bold;
        justify-content: center;
        align-items: center;
        color: black;
    }

    .class-split {
        width: 95%;
        height: 1px;
        border-top: 2px dotted lightgrey;
    }
</style>
